export const CLOUD_STYLE_PRESETS = Object.freeze( {
	cumulus: Object.freeze( {
		label: 'Cumulus',
		coverage: 0.29,
		density: 1,
		softness: 0.085,
		bottomFade: 0.13,
		topFade: 0.34,
		anvil: 0.22,
		detailErosion: 0.78,
		detailContrast: 1.45,
		formationStrength: 0.48,
		formationSpeed: 0.09,
		roilStrength: 0.48,
		roilSpeed: 0.3,
		extinction: 0.023,
		ambientIntensity: 0.28
	} ),
	stormfront: Object.freeze( {
		label: 'Stormfront',
		coverage: 0.57,
		density: 1.42,
		softness: 0.14,
		bottomFade: 0.09,
		topFade: 0.26,
		anvil: 0.72,
		detailErosion: 0.52,
		detailContrast: 1.15,
		formationStrength: 0.32,
		formationSpeed: 0.055,
		roilStrength: 0.32,
		roilSpeed: 0.2,
		extinction: 0.038,
		ambientIntensity: 0.18,
		cloudColor: '#aebdca'
	} ),
	wispy: Object.freeze( {
		label: 'High wisps',
		coverage: 0.2,
		density: 0.56,
		softness: 0.19,
		bottomFade: 0.3,
		topFade: 0.48,
		anvil: 0.08,
		detailErosion: 0.32,
		detailContrast: 1.6,
		detailScale: 4.8,
		formationStrength: 0.25,
		formationSpeed: 0.12,
		roilStrength: 0.65,
		roilSpeed: 0.42,
		extinction: 0.012,
		ambientIntensity: 0.4
	} ),
	towering: Object.freeze( {
		label: 'Towering',
		coverage: 0.38,
		density: 1.08,
		softness: 0.1,
		bottomFade: 0.14,
		topFade: 0.31,
		anvil: 0.35,
		detailErosion: 0.66,
		detailContrast: 1.5,
		formationStrength: 0.55,
		formationSpeed: 0.07,
		roilStrength: 0.52,
		roilSpeed: 0.26,
		extinction: 0.026,
		ambientIntensity: 0.32
	} )
} );

export function getCloudStylePreset( name = 'cumulus' ) {

	const preset = CLOUD_STYLE_PRESETS[ name ];
	if ( ! preset ) throw new RangeError( `Unknown cloud style preset: ${ name }` );
	return { ...preset };

}
